<template>
  <div class="picscompo">
    <v-pics-compo
      class="hero__pics"
      :firstImg="compoImages.first"
      :secondImg="compoImages.second"
      :thirdImg="compoImages.third"
      @imageIndx="imageClicked"
    ></v-pics-compo>

    <!-- LIGHT-BOX -->
    <v-light-box
      :showLightbox="lightbox"
      @hideLightbox="lightbox = false"
      :images="lightboxGallery"
      :startAt="lightboxIdx"
    ></v-light-box>
  </div>
</template>

<script>
import VPicsCompo from '@/components/atomic/VPicsCompo.vue';
import VLightBox from '@/components/atomic/VLightBox.vue';

export default {
  name: 'AgiosPicsCompo',
  components: {
    VPicsCompo,
    VLightBox,
  },
  data() {
    return {
      lightbox: false,
      lightboxIdx: 0,
      compoImages: {
        first: {
          url:
            'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,h_154,q_auto:best,w_220/v1628782776/AgiosPage/agios-3_ecrbzf.jpg',
          alt: 'agios nikolaos halkidiki rizes house',
        },

        second: {
          url:
            'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,h_154,q_auto:best,w_220/v1628782778/AgiosPage/agios-2_fouxjv.jpg',
          alt: 'agios nikolaos halkidiki rizes house',
        },

        third: {
          url:
            'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,h_154,q_auto:best,w_220/v1628782784/AgiosPage/agios-1_gkgkyq.jpg',
          alt: 'agios nikolaos halkidiki rizes house',
        },
      },
      lightboxGallery: [
        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,h_154,q_auto:best,w_600/v1628782776/AgiosPage/agios-3_ecrbzf.jpg',
        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,h_154,q_auto:best,w_600/v1628782778/AgiosPage/agios-2_fouxjv.jpg',
        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,h_154,q_auto:best,w_600/v1628782784/AgiosPage/agios-1_gkgkyq.jpg',
      ],
    };
  },
  methods: {
    imageClicked(idx) {
      this.lightbox = true;
      this.lightboxIdx = idx;
    },
  },
};
</script>

<style scoped lang="scss">
.picscompo {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
